/**
 * Shared narration styling helpers for amortization / preview tables.
 * Keeps the narration Chip colouring consistent between AmortizationScheduleTable
 * and the rate-change comparison table so previews read like the contract view.
 */

// Determine if an entry is an inflow / outflow / accrual based on its narration.
export const getNarrationFlowType = (narration) => {
  if (!narration) return 'neutral';
  // Inflows — money coming IN from the investor
  if (narration.includes('Drawdown') || narration.includes('Opening Balance') || narration.includes('Injection')) return 'inflow';
  // Outflows — money going OUT to the investor
  if (narration.includes('Payment') || narration.includes('Fee') || narration.includes('Duty') || narration.includes('Withdrawal')) return 'outflow';
  // Accruals — not actual cash flow
  if (narration.includes('Accrual') || narration === 'Interest Float') return 'accrual';
  return 'neutral';
};

// MUI Chip `color` for a narration.
export const getNarrationColor = (narration) => {
  if (!narration) return 'default';
  if (narration.includes('Injection')) return 'success';
  if (narration.includes('Withdrawal')) return 'warning';
  const flowType = getNarrationFlowType(narration);
  if (flowType === 'inflow') return 'info';
  if (flowType === 'outflow') return 'error';
  if (flowType === 'accrual') return 'warning';
  return 'default';
};

// Full prop set for the narration Chip so call sites stay one-liners.
// Carried Interest Accrual reads as a distinct (deep-purple) category.
export const getNarrationChipProps = (narration) => {
  if (narration === 'Carried Interest Accrual') {
    return {
      variant: 'outlined',
      sx: { color: '#7b1fa2', borderColor: '#7b1fa2', fontWeight: 600 },
    };
  }
  return {
    variant: 'outlined',
    color: getNarrationColor(narration),
  };
};
